// Recursively extract default values from a JSON schema. Single source for the
// inboedel/woonhuis/aansprakelijkheid calc chains (each calc.ts re-exports it, so barrels and
// tests keep importing from './calc').
export const extractDefaults = (schema: any): any => {
  if (!schema || typeof schema !== 'object') {
    return {};
  }

  const defaults: any = {};

  if (schema.properties) {
    for (const key in schema.properties) {
      const field = schema.properties[key];

      // If field has a default value, use it
      if (field.default !== undefined) {
        defaults[key] = field.default;
      }

      // If field has nested properties, recurse
      if (field.properties) {
        defaults[key] = {
          ...defaults[key],
          ...extractDefaults(field)
        };
      }
    }
  }

  return defaults;
};
